import { UserPermissionV2 } from '@bm-js/atlascloud-shared'

export enum ROUTE {
  DASHBOARD = '/',
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  REGISTER = '/register',
  GET_STARTED = '/kom-igang',
  USERS = '/users',
  CUSTOMER_USERS = '/customer-users',
  MEDIA = '/media',
  EDITOR = '/editor/:id',
  EDITOR_MOBILE = '/editor-mobile',
  CMS_EDITOR = '/cms-editor/:id',
  BLOG = '/blog',
  CALENDAR = '/calendar',
  SPONSORS = '/sponsors',
  ACCOUNT = '/account',
  COURSES = '/courses',
  COURSE = '/courses/:id',
  ECOMMERCE = '/ecommerce',
  CUSTOMER_USER_REGISTER = '/customer-user-register',
  CUSTOMER_USER_REQUEST_PASSWORD_RESET = '/customer-user-request-password-reset',
  CUSTOMER_USER_RESET_PASSWORD = '/customer-user-reset-password',
}

export const RoutePermissions: Record<ROUTE, UserPermissionV2[]> = {
  [ROUTE.DASHBOARD]: [UserPermissionV2.ADMIN],
  [ROUTE.LOGIN]: [],
  [ROUTE.FORGOT_PASSWORD]: [],
  [ROUTE.RESET_PASSWORD]: [],
  [ROUTE.REGISTER]: [],
  [ROUTE.GET_STARTED]: [],
  [ROUTE.USERS]: [UserPermissionV2.ADMIN],
  [ROUTE.CUSTOMER_USERS]: [UserPermissionV2.ADMIN],
  [ROUTE.MEDIA]: [UserPermissionV2.ADMIN],
  [ROUTE.EDITOR]: [UserPermissionV2.ADMIN],
  [ROUTE.EDITOR_MOBILE]: [UserPermissionV2.ADMIN],
  [ROUTE.CMS_EDITOR]: [UserPermissionV2.ADMIN],
  [ROUTE.BLOG]: [UserPermissionV2.ADMIN],
  [ROUTE.CALENDAR]: [UserPermissionV2.ADMIN],
  [ROUTE.SPONSORS]: [UserPermissionV2.ADMIN],
  [ROUTE.ACCOUNT]: [UserPermissionV2.ADMIN],
  [ROUTE.COURSES]: [UserPermissionV2.ADMIN],
  [ROUTE.COURSE]: [UserPermissionV2.ADMIN],
  [ROUTE.ECOMMERCE]: [UserPermissionV2.ADMIN],
  [ROUTE.CUSTOMER_USER_REGISTER]: [],
  [ROUTE.CUSTOMER_USER_REQUEST_PASSWORD_RESET]: [],
  [ROUTE.CUSTOMER_USER_RESET_PASSWORD]: [],
}

export const routesWithoutLayout: ROUTE[] = [
  ROUTE.LOGIN,
  ROUTE.REGISTER,
  ROUTE.FORGOT_PASSWORD,
  ROUTE.RESET_PASSWORD,
  ROUTE.CUSTOMER_USER_REGISTER,
  ROUTE.CUSTOMER_USER_REQUEST_PASSWORD_RESET,
  ROUTE.CUSTOMER_USER_RESET_PASSWORD,
  ROUTE.GET_STARTED,
  ROUTE.EDITOR,
  ROUTE.EDITOR_MOBILE,
  ROUTE.CMS_EDITOR,
]

export const authenticatedDisallowedRoutes: ROUTE[] = [
  ROUTE.LOGIN,
  ROUTE.REGISTER,
  ROUTE.FORGOT_PASSWORD,
  ROUTE.RESET_PASSWORD,
  ROUTE.CUSTOMER_USER_REGISTER,
  ROUTE.CUSTOMER_USER_REQUEST_PASSWORD_RESET,
  ROUTE.CUSTOMER_USER_RESET_PASSWORD,
  ROUTE.GET_STARTED,
]
